// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"ab0e616e","247":"6f71695b","284":"f89a72e6","484":"f4b93c43","498":"377ac2ec","551":"1e52553c","623":"8584e990","627":"d63d833a","867":"3792e14b","923":"d7e0cc20","938":"fb9e81bd"}[chunkId] + ".chunk.js";
};